import type {Breadcrumb, BreadcrumbHint, Event, EventHint} from '@sentry/types';

import {urlSanitizer} from '@/services/sanitizers';

export function sentryEventSanitizer<T extends Event>(event: T, _hint: EventHint) {
    if (event.request) {
        if (event.request.url) {
            event.request.url = urlSanitizer(event.request.url);
        }
        if (event.request.headers?.Referer) {
            event.request.headers.Referer = urlSanitizer(event.request.headers.Referer);
        }
    }

    event.transaction = event.transaction
        ? urlSanitizer(event.transaction)
        : event.transaction;
    return event;
}

export function sentryBreadcrumbSanitizer(breadcrumb: Breadcrumb, _hint?: BreadcrumbHint) {
    const data = breadcrumb.data || {};
    if (data.url) {
        data.url = urlSanitizer(data.url);
    }
    if (data.from) {
        data.from = urlSanitizer(data.from);
    }
    if (data.to) {
        data.to = urlSanitizer(data.to);
    }
    return {...breadcrumb, data};
}
